module.exports = __webpack_public_path__ + "static/img/testimonial-bg.27fa8b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testimonial-bg.png
// module id = piVB
// module chunks = 36